import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { createLiveSession } from "../../services/liveSessionApi";

// Director session builder (Q7-T1 §4.3) — a thin caller over the existing
// create-quiz shape: assemble params and dispatch the create call. The ENTRY POINT
// is gated by the build-time UI flag REACT_APP_ENABLE_LIVE_SESSION; the server also
// 404s every route until qlearn.live-session.enabled, so this is dark twice over.
const LIVE_SESSION_UI_ENABLED = process.env.REACT_APP_ENABLE_LIVE_SESSION === "true";

export default function LiveSessionBuilder() {
    const history = useHistory();
    const [name, setName] = useState("");
    const [noOfQuestions, setNoOfQuestions] = useState(5);
    const [examType, setExamType] = useState("");
    const [error, setError] = useState("");
    const [creating, setCreating] = useState(false);

    if (!LIVE_SESSION_UI_ENABLED) {
        return <div style={{ padding: 24 }}>Live sessions are not available.</div>;
    }

    const onCreate = async () => {
        setError("");
        setCreating(true);
        try {
            const categoryMap = examType ? { examType: [examType] } : undefined;
            const resp = await createLiveSession({ name, noOfQuestions: Number(noOfQuestions), categoryMap });
            history.push(`/live/present/${resp.sessionId}`);
        } catch (e) {
            setError(e && e.message ? e.message : "Could not create the session");
        } finally {
            setCreating(false);
        }
    };

    return (
        <div style={{ maxWidth: 520, margin: "2rem auto", fontFamily: "system-ui, sans-serif" }}>
            <h1>Start a live session</h1>
            <p>Build a room from your question bank. Participants join by QR code and answer on their phones.</p>
            <label style={{ display: "block", margin: ".5rem 0" }}>
                Session name
                <input value={name} onChange={(e) => setName(e.target.value)} style={{ width: "100%", padding: 8 }} />
            </label>
            <label style={{ display: "block", margin: ".5rem 0" }}>
                Number of questions (max 20)
                <input type="number" min={1} max={20} value={noOfQuestions}
                       onChange={(e) => setNoOfQuestions(e.target.value)} style={{ width: "100%", padding: 8 }} />
            </label>
            <label style={{ display: "block", margin: ".5rem 0" }}>
                Exam type (optional)
                <input value={examType} onChange={(e) => setExamType(e.target.value)} style={{ width: "100%", padding: 8 }} />
            </label>
            {error && <p style={{ color: "#b00020" }}>{error}</p>}
            <button onClick={onCreate} disabled={creating} style={{ padding: "10px 18px", marginTop: 12 }}>
                {creating ? "Creating…" : "Create session"}
            </button>
        </div>
    );
}
